export const formatOrderId = ({ lastOrderId, lastServiceId, lastLocationId, companyId }: {
  lastOrderId: number,
  lastServiceId: number,
  lastLocationId: number,
  companyId: number
}): string => {
  const paddedOrderId = String(lastOrderId).padStart(3, '0');
  const paddedServiceId = String(lastServiceId).padStart(3, '0');
  const paddedLocationId = String(lastLocationId).padStart(4, '0');
  const paddedCompanyId = String(companyId).padStart(4, '0');
  const currentYear = new Date().getFullYear();

  return `${paddedCompanyId}-${currentYear}-${paddedServiceId}-${paddedLocationId}-${paddedOrderId}`;
};
